"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _gridItemFraction = _interopRequireDefault(require("./gridItemFraction"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * TO DO
 * Criar verificação obrigatória 'isRequired`
 * https://github.com/facebook/react/issues/9125
 */
var _default = exports["default"] = {
  gridItemFraction: _gridItemFraction["default"]
};